import PlatformManagement from './PlatformManagement.jsx';
import PlatformHealthDashboard, { HEALTH_VIEWS } from './PlatformHealthDashboard.jsx';

const HEALTH_VIEW_KEYS = new Set(HEALTH_VIEWS.map((view) => view.key));

// The rendered Platform Health navigation is the only source of truth for its
// public routes. This prevents an old allowlist from making a newly rendered
// view unreachable.
export function resolvePlatformOpsView(requestedView, {
  catalogManagerAllowed = false,
  companyOnboardingAllowed = false,
  userManagerAllowed = false,
} = {}) {
  const candidate = String(requestedView || 'overview').trim().toLowerCase();
  if (candidate === 'companies') return companyOnboardingAllowed ? candidate : 'overview';
  if (candidate === 'users') return userManagerAllowed ? candidate : 'overview';
  if (candidate === 'catalog') return catalogManagerAllowed ? candidate : 'overview';
  return HEALTH_VIEW_KEYS.has(candidate) ? candidate : 'overview';
}

export default function PlatformOpsDashboard({ session = {}, navigate, requestedView = 'overview' }) {
  const platform = session.user?.platform || {};
  const capabilities = Array.isArray(platform.capabilities) ? platform.capabilities : [];
  const activeView = resolvePlatformOpsView(requestedView, {
    companyOnboardingAllowed: Boolean(platform.admin && capabilities.includes('platform.companies.manage')),
    catalogManagerAllowed: Boolean(platform.admin && capabilities.includes('platform.catalog.manage')),
    userManagerAllowed: Boolean(platform.admin && capabilities.includes('platform.users.read')),
  });

  if (['companies', 'catalog', 'users'].includes(activeView)) {
    return <PlatformManagement session={session} view={activeView} />;
  }
  return <PlatformHealthDashboard session={session} navigate={navigate} activeView={activeView} />;
}
